import { render, staticRenderFns } from "./VoiceConfiguration.vue?vue&type=template&id=62992d4a&scoped=true"
import script from "./VoiceConfiguration.vue?vue&type=script&lang=js"
export * from "./VoiceConfiguration.vue?vue&type=script&lang=js"
import style0 from "./VoiceConfiguration.vue?vue&type=style&index=0&id=62992d4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62992d4a",
  null
  
)

export default component.exports